module.exports = __webpack_public_path__ + "img/certificate.cd5064d5.jpg";